// Менеджер попапов для VROC компонентов
export class PopupManager {
	constructor() {
		this.activeStack = [];
		this.isInitialized = false;
		this.eventHandlers = new Map(); // Система событий
	}

	/**
	 * Инициализирует все попапы на странице (статические и динамические)
	 */
	init() {
		// Инициализируем глобальные события
		this.initGlobal();
		
		// Находим и привязываем события ко всем существующим попапам
		document.querySelectorAll('.popup[data-popup-name]').forEach(popup => {
			this.bindPopupEvents(popup);
		});
	}

	/**
	 * Инициализирует глобальные события попапов (вызывается один раз)
	 */
	initGlobal() {
		if (this.isInitialized) return;
		
		this.bindDocumentClick();
		this.bindEscapeKey();
		this.isInitialized = true;
	}

	/**
	 * Привязывает события к конкретному попапу
	 * @param {HTMLElement} popupElement - Элемент попапа
	 */
	bindPopupEvents(popupElement) {
		if (!popupElement || !popupElement.classList.contains('popup')) {
			return;
		}

		const popupName = popupElement.getAttribute('data-popup-name');
		if (!popupName) {
			console.warn('Popup element missing data-popup-name attribute');
			return;
		}

		// Привязываем кнопки открытия
		this.bindOpenButtons(popupElement);
		
		// Привязываем кнопки закрытия внутри попапа
		this.bindCloseButtons(popupElement);
		
		// Привязываем клик по фону
		this.bindOverlayClick(popupElement);
	}

	/**
	 * Привязывает кнопки открытия попапа
	 * @param {HTMLElement} popupElement - Элемент попапа
	 */
	bindOpenButtons(popupElement) {
		const popupName = popupElement.getAttribute('data-popup-name');
		
		// Находим все кнопки, которые открывают этот попап
		document.querySelectorAll(`[data-popup-open="${popupName}"]`).forEach(btn => {
			// Удаляем существующие обработчики, чтобы избежать дублирования
			btn.removeEventListener('click', this.handleOpenClick);
			
			btn.addEventListener('click', this.handleOpenClick.bind(this));
		});
	}

	/**
	 * Привязывает кнопки закрытия внутри попапа
	 * @param {HTMLElement} popupElement - Элемент попапа
	 */
	bindCloseButtons(popupElement) {
		const popupName = popupElement.getAttribute('data-popup-name');
		
		popupElement.querySelectorAll('[data-popup-close="true"]').forEach(btn => {
			// Удаляем существующие обработчики
			btn.removeEventListener('click', this.handleCloseClick);
			
			btn.addEventListener('click', (e) => {
				e.stopPropagation();
				this.close(popupName);
			});
		});
	}

	/**
	 * Привязывает клик по фону попапа
	 * @param {HTMLElement} popupElement - Элемент попапа
	 */
	bindOverlayClick(popupElement) {
		const popupName = popupElement.getAttribute('data-popup-name');
		
		// Удаляем существующие обработчики
		popupElement.removeEventListener('click', this.handleOverlayClick);
		
		popupElement.addEventListener('click', (e) => {
			if (e.target !== popupElement) return;
			if (e.target.closest('[data-popup-close="false"]')) return;
			this.close(popupName);
			e.stopPropagation();
		});
	}

	/**
	 * Обработчик клика по кнопке открытия
	 * @param {Event} e - Событие клика
	 */
	handleOpenClick(e) {
		const name = e.currentTarget.getAttribute('data-popup-open');
		const insideFalse = e.currentTarget.closest('[data-popup-close="false"]');
		const isOpen = this.activeStack.includes(name);

		// Если этот попап ещё не открыт и кнопка вне зоны data-popup-close="false" —
		// сначала закрываем все остальные
		if (!isOpen && !insideFalse) {
			this.closeAll();
		}

		this.toggle(name);
	}

	/**
	 * Обработчик клика по кнопке закрытия
	 * @param {Event} e - Событие клика
	 */
	handleCloseClick(e) {
		e.stopPropagation();
		const popup = e.currentTarget.closest('.popup');
		if (!popup) return;
		this.close(popup.getAttribute('data-popup-name'));
	}

	/**
	 * Обработчик клика по фону попапа
	 * @param {Event} e - Событие клика
	 */
	handleOverlayClick(e) {
		if (e.target !== e.currentTarget) return;
		if (e.target.closest('[data-popup-close="false"]')) return;
		this.close(e.currentTarget.getAttribute('data-popup-name'));
		e.stopPropagation();
	}

	/**
	 * Привязывает глобальные события (клик по документу и Escape)
	 */
	bindDocumentClick() {
		document.addEventListener('click', (e) => {
			// если кликнули по кнопке открытия открытого попапа — не закрываем
			const toggler = e.target.closest('[data-popup-open]');
			if (toggler && this.activeStack.includes(toggler.getAttribute('data-popup-open'))) {
				return;
			}
			// если кликнут внутри любого попапа — не закрываем
			const clickedPopup = e.target.closest('.popup');
			if (clickedPopup) {
				return;
			}
			// если есть открытый попап с data-popup-close="false" — не закрываем
			if (document.querySelector('.popup.active[data-popup-close="false"]')) {
				return;
			}
			this.closeAll();
		});
	}

	/**
	 * Привязывает обработчик клавиши Escape
	 */
	bindEscapeKey() {
		document.addEventListener('keydown', (e) => {
			if (e.key === 'Escape') {
				// если есть открытый попап с data-popup-close="false" — не закрываем
				if (document.querySelector('.popup.active[data-popup-close="false"]')) {
					return;
				}

				e.preventDefault();
				this.closeAll();
			}
		});
	}

	/**
	 * Открывает попап
	 * @param {string} name - Имя попапа
	 */
	open(name) {
		const popup = document.querySelector(`.popup[data-popup-name="${name}"]`);
		if (!popup || this.activeStack.includes(name)) return;
		
		this.activeStack.push(name);
		popup.classList.add('active');
		
		if (this.activeStack.length === 1) {
			document.body.classList.add('no-scroll');
		}
	}

	/**
	 * Закрывает попап
	 * @param {string} name - Имя попапа
	 */
	close(name) {
		const idx = this.activeStack.lastIndexOf(name);
		if (idx === -1) return;
		
		this.activeStack.splice(idx, 1);
		const popup = document.querySelector(`.popup[data-popup-name="${name}"]`);
		
		if (popup) {
			popup.classList.remove('active');
		}
		
		if (this.activeStack.length === 0) {
			document.body.classList.remove('no-scroll');
		}

		// Уведомляем подписчиков о закрытии попапа
		this._emit('popupClosed', name);
	}

	/**
	 * Закрывает все попапы
	 */
	closeAll() {
		// клонируем стек, чтобы не мутировать его во время итерации
		this.activeStack.slice().forEach(name => this.close(name));
	}

	/**
	 * Переключает состояние попапа
	 * @param {string} name - Имя попапа
	 */
	toggle(name) {
		if (this.activeStack.includes(name)) {
			this.close(name);
		} else {
			this.open(name);
		}
	}

	/**
	 * Проверяет, является ли элемент попапом
	 * @param {HTMLElement} element - Элемент для проверки
	 * @returns {boolean} - true, если элемент является попапом
	 */
	isPopup(element) {
		return element && element.classList.contains('popup') && 
			   element.hasAttribute('data-popup-name');
	}

	/**
	 * Подписывается на событие
	 * @param {string} eventName - Название события
	 * @param {Function} handler - Обработчик события
	 */
	on(eventName, handler) {
		if (!this.eventHandlers.has(eventName)) {
			this.eventHandlers.set(eventName, []);
		}
		this.eventHandlers.get(eventName).push(handler);
	}

	/**
	 * Отписывается от события
	 * @param {string} eventName - Название события
	 * @param {Function} handler - Обработчик события
	 */
	off(eventName, handler) {
		if (this.eventHandlers.has(eventName)) {
			const handlers = this.eventHandlers.get(eventName);
			const index = handlers.indexOf(handler);
			if (index > -1) {
				handlers.splice(index, 1);
			}
		}
	}

	/**
	 * Вызывает событие
	 * @param {string} eventName - Название события
	 * @param {*} data - Данные события
	 */
	_emit(eventName, data) {
		if (this.eventHandlers.has(eventName)) {
			this.eventHandlers.get(eventName).forEach(handler => {
				try {
					handler(data);
				} catch (error) {
					console.error(`Error in PopupManager event handler for ${eventName}:`, error);
				}
			});
		}
	}
}

// Экспортируем синглтон для глобального использования
export const popupManager = new PopupManager();
